'use strict';

const Mn = require('backbone.marionette');
const Template = require('common/ui/template/project/member-name.hbs');

module.exports = Mn.View.extend({
    large: false,

    tagName: 'span',
    className: 'project-member-name',
    template: Template,
    serializeData: function() {
        return {
            name: this.model.getUser().getName(),
            isSuspended: this.model.isSuspended()
        };
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/project/member-name.js